import * as React from 'react';
import './PayResponse.scss';
import InterfaceIcon from '../../../../../assets/interface';
import PrintIcon from '../../../../../assets/print';
import exportIcon from '../../../../../assets/export';
import downarrowIcon from '../../../../../assets/downArrow';
import { currencyFormatter } from 'src/utils/currencyFormatter';
import i18n from 'src/translation/i18n';

class PayResponse extends React.Component<any> {
  public Backinvoices = () => {
    this.props.history.push('/invoices');
  };
  public getInvoiceCount = () => {
    if (
      this.props.location &&
      this.props.location.state &&
      this.props.location.state.orderlistLength
    ) {
      return this.props.location.state.orderlistLength;
    }
    return 0;
  };
  public render() {
    return (
      <div className="apply-credit responsive-apply-credit">
        <img className="interface-icon" src={InterfaceIcon} />
        <div className="success-msg">
          {' '}
          {i18n.t('invoices.successfullyMadeThePayment')}
        </div>
        <button className="back-btn" onClick={this.Backinvoices}>
          {i18n.t('invoices.backToOpenInvoices')}
        </button>
        <div className="transaction-details">
          <div className="details-label">
            {i18n.t('invoices.transactionDetails')}
          </div>
          <div className="d-flex amount-details">
            <span className="credit-used-amount">
              {i18n.t('invoices.Paid')} <b>{this.getInvoiceCount()}</b>{' '}
              {i18n.t('invoices.invoicesOf')}
              <b>
                {` ${
                  this.props.location &&
                  this.props.location.state &&
                  this.props.location.state.creditUsed
                    ? currencyFormatter(this.props.location.state.creditUsed)
                    : currencyFormatter(0)
                }`}{' '}
              </b>
            </span>
            {/* <span className="line-gap">|</span>
            <span className="credit-used-amount">
              <b>$2,000.00</b> paid using E-check
            </span> */}
          </div>
          {this.props.location.state &&
            this.props.location.state.trackingNumber && (
              <div className="f-20-px">
                {' '}
                {i18n.t('invoices.yourReferenceNumber')}:{' '}
                <b>{this.props.location.state.trackingNumber}</b>
              </div>
            )}

          {/* <div className="d-flex justify-content-center">
            <div className="print">
              <img className="image-icon" src={PrintIcon} />
              <span className="Print-label">Print</span>
            </div>
            <div className="export">
              <img className="image-icon" src={exportIcon} />
              <span className="Print-label">Export</span>
              <img className="down-arrow" src={downarrowIcon} />
            </div>
          </div> */}
        </div>
      </div>
    );
  }
}

export default PayResponse;
